export default {
  chat: '/csh5/courier/aihelper/chat',
  queryArticlesByPlatformId: '/gateway/cms/faq/queryArticlesByPlatformId',
  conversation: '/csh5/courier/aihelper/feedback/conversation',
  end: '/csh5/courier/aihelper/conversation/end',
  getGroupId: '/v3/cs/getCustomTeamId',
  welcome: '/csh5/courier/aihelper/getCourierPortrait',
  citySwitch: '/v3/cs/mileageCourier/citySwitch',
  getHotLine: '/v3/config/courier/hotline',
  toCondition: '/cs/ticket/ai/condition',
  aiChat: '/csh5/courier/aihelper/aiChat'
}
